// extracted by mini-css-extract-plugin
export default {"mainWrapper":"styles_mainWrapper__kkWVR","container":"styles_container__-A+pA","bannerContent":"styles_bannerContent__VSelH","backgroundImage":"styles_backgroundImage__uXMXG"};